import React from 'react';

import UnderConstructionPage from './UnderConstructionPage';

const PrivacyPage: React.FC = () => <UnderConstructionPage />;

export default PrivacyPage;
